import { render, staticRenderFns } from "./DocumentsUpload.vue?vue&type=template&id=6e71dcd4&scoped=true&"
import script from "./DocumentsUpload.vue?vue&type=script&lang=ts&"
export * from "./DocumentsUpload.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsUpload.vue?vue&type=style&index=0&id=6e71dcd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71dcd4",
  null
  
)

export default component.exports